import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useGetPathToEntityDetail } from '../../hooks';

export const useRedirectToEventDetail = () => {
  const getPathToEntityDetail = useGetPathToEntityDetail();
  const navigate = useNavigate();
  const { search } = useLocation();

  return useCallback(
    async (id: string) => {
      await navigate({ pathname: getPathToEntityDetail(id, { entityType: 'event' }), search }, { replace: true });
    },
    [getPathToEntityDetail, navigate, search],
  );
};
